import { V1A_IMG } from '../constants';

/** `srcSet` for the responsive rasters of this page: `name-<width>.<ext>` under V1A_IMG. */
export function imageSrcSet(name: string, widths: readonly number[], extension: 'avif' | 'webp'): string {
  return widths.map((width) => `${V1A_IMG}/${name}-${width}.${extension} ${width}w`).join(', ');
}

export function imageSrc(file: string): string {
  return `${V1A_IMG}/${file}`;
}

/** Integers in the visitor's locale, always with Latin digits (Arabic would otherwise switch to ١٢٣). */
export function formatInteger(htmlLang: string, value: number): string {
  try {
    return new Intl.NumberFormat(`${htmlLang}-u-nu-latn`, { maximumFractionDigits: 0 }).format(value);
  } catch {
    return String(Math.round(value));
  }
}
